import { useMemo } from 'react';
import { FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { travelReturnModeList } from '@/module/Travel/Settings/model/TravelSettingsTypes';

import { EnumSelectControl, EnumSelectControlProps } from '@/core/components';

export type TravelReturnModeSelectControlProps<T extends FieldValues> = Omit<EnumSelectControlProps<T>, 'options'>;

export function TravelReturnModeSelectControl<T extends FieldValues>(props: TravelReturnModeSelectControlProps<T>) {
  const { t } = useTranslation();
  const options = useMemo(
    () => travelReturnModeList.map(value => ({ value, label: t(`travel.returnModeEnum.${value}`) })),
    [t],
  );

  return (
    <EnumSelectControl
      {...props}
      options={options}
    />
  );
}
